// combines all modules
import Vuex from 'vuex';
import Vue from 'vue';
import auth from './modules/auth';
import autoagree from './modules/autoagree';
import brokerdealer from './modules/brokerdealer';
import clientmanage from './modules/clientmanage';
import dashboard from './modules/dashboard';
import globals from './modules/globals';
import plan from './modules/plan';
import proposal from './modules/proposal';
import proposalBuilder from './modules/proposalBuilder';
import repuser from './modules/repuser';
import settings from './modules/settings';
import status from './modules/status';
import template from './modules/template';
import tpa from './modules/tpa';
import user from './modules/user';
import utility from './modules/utility';
import wholesaler from './modules/wholesaler';



// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
    modules: {
        auth,
        autoagree,
        brokerdealer,
        clientmanage,
        dashboard,
        globals,
        plan,
        proposal,
        proposalBuilder,
        repuser,
        settings,
        status,
        template,
        tpa,
        user,
        utility,
        wholesaler,
    },
})